import { trackEventLogic } from './trackEventLogic';
import { registerSplitsLogic } from './registerSplitsLogic';
import { fetchTreatmentsLogic } from './fetchTreatmentsLogic';
import { trackBookingLogic } from './trackBookingLogic';

export const logic = [trackEventLogic, registerSplitsLogic, fetchTreatmentsLogic, trackBookingLogic];
